module.exports = __webpack_public_path__ + "media/25-Avanti_Peusangan_Testimonial.3b17ac86.mp3";